import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  margin: 7px auto 10px;\n  position: relative;\n  width: 90%;\n'], ['\n  display: flex;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  margin: 7px auto 10px;\n  position: relative;\n  width: 90%;\n']);

import styled from 'styled-components';

export var StyledDiv = styled.div(_templateObject);